// @ts-nocheck
import * as React from "react";

const BellFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M5 18.77v-1h1.615V9.845c0-1.306.414-2.455 1.24-3.447A5.272 5.272 0 0 1 11 4.546V3h2v1.546A5.272 5.272 0 0 1 16.144 6.4c.827.992 1.24 2.14 1.24 3.447v7.923H19v1H5Zm6.996 2.614c-.445 0-.825-.158-1.14-.474a1.559 1.559 0 0 1-.472-1.14h3.232c0 .447-.16.828-.476 1.143a1.564 1.564 0 0 1-1.144.471Zm-4.38-3.615h8.768V9.846c0-1.215-.426-2.25-1.28-3.104-.854-.854-1.889-1.28-3.104-1.28s-2.25.426-3.104 1.28c-.854.854-1.28 1.889-1.28 3.104v7.923Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(BellFill);
